import React, { PropsWithChildren } from "react";
import {
  useTheme,
  AHText,
  Box,
  AHTextFonts,
  AHTextProps,
  AHButton,
  AHButtonProps,
  AHIcon,
  AHIconType,
} from "arkh";

export function ActionCardTitle({
  children,
}: {
  children: AHTextProps["children"];
}) {
  return (
    <AHText style={{ textAlign: "center" }} type="title-big">
      {children}
    </AHText>
  );
}
export function ActionCardDescriptionContainer({
  children,
}: PropsWithChildren<object>) {
  return (
    <Box spaceVertical="small" style={{ alignSelf: "center" }}>
      {children}
    </Box>
  );
}
export function ActionCardDescription({
  children,
  font = AHTextFonts.REGULAR,
  ...props
}: Pick<
  AHTextProps,
  "font" | "children" | "spaceTop" | "spaceBottom" | "style" | "onPress"
>) {
  return (
    <AHText type="title-small" font={font} {...props}>
      {children}
    </AHText>
  );
}
export function ActionCard({ children }: PropsWithChildren<object>) {
  return (
    <Box
      space="large"
      color="surface"
      cornerRadius="large"
      borderColor="border-primary"
      style={{
        borderWidth: 1,
        flexShrink: 1,

        maxWidth: 560,
      }}
    >
      {children}
    </Box>
  );
}
export function ActionCardIcon({ name }: { name: AHIconType }) {
  const theme = useTheme();
  return (
    <Box spaceVertical="xlarge">
      <Box
        style={{
          width: 80,
          height: 80,
          borderRadius: 40,
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 3,
          alignSelf: "center",
        }}
        borderColor="primary"
      >
        <AHIcon type={name} customColor={theme.primary} forceSize={40} />
      </Box>
    </Box>
  );
}

export function ActionCardButton(
  props: Pick<
    AHButtonProps,
    | "onPress"
    | "iconType"
    | "title"
    | "iconLeft"
    | "loading"
    | "disabled"
    | "hideIfDisabled"
  >
) {
  return (
    <Box spaceTop="large">
      <AHButton themeType="primary" {...props} />
    </Box>
  );
}
